module.exports.Component = AFRAME.registerComponent('scene2', {
  schema: {
    sceneModel: {default: ''},
    nftTextureSrc: {default: ''},
    frameStyle: {default: 1, min: 1, max: 10},
    roomStyle: {default: 1, min: 1, max: 4},
    aspectRatio: {default: 'squared', oneOf: ['squared', 'portrait', 'landscape']},
    nftColors: {default: true},
    fogDensity: {default: 0.06}
  },

  textures: [
    './assets/textures/scene2/style1.jpg',
    './assets/textures/scene2/style2.jpg',
    './assets/textures/scene2/style3.jpg',
    './assets/textures/scene2/style4.jpg',
    './assets/textures/scene2/lightmap-landscape.jpg',
    './assets/textures/scene2/lightmap-portrait.jpg',
    './assets/textures/scene2/lightmap-squared.jpg'
  ],

  cameraAnimations: [
    {
      initialPosition: new THREE.Vector3(-0.786, 1.1, 0.21),
      initialRotation: new THREE.Vector3(0.012, -0.015, 0),
      finalPosition: new THREE.Vector3(0.206, 1.1, 0.234),
      finalRotation: new THREE.Vector3(0.012, -0.015, 0),
      duration: 5000
    },
    {
      initialPosition: new THREE.Vector3(0, 1, -1),
      initialRotation: new THREE.Vector3(0, 0, 0),
      finalPosition: new THREE.Vector3(0, 1, 0.2),
      finalRotation: new THREE.Vector3(0, 0, 0),
      duration: 5000
    },
    {
      initialPosition: new THREE.Vector3(0.82, 1, -0.48),
      initialRotation: new THREE.Vector3(-0.12, 33.8, 0),
      finalPosition: new THREE.Vector3(1.33, 1, -0.82),
      finalRotation: new THREE.Vector3(-0.12, 33.8, 0),
      duration: 5000
    }
  ],

  init: function () {
    var system = this.el.sceneEl.systems.scene;
    this.onModelLoaded = system.onModelLoaded.bind(this);
    this.onTexturesPreloaded = this.onTexturesPreloaded.bind(this);
    this.el.sceneEl.addEventListener('texturespreloaded', this.onTexturesPreloaded);
    this.el.addEventListener('model-loaded', this.onModelLoaded);
    this.el.setAttribute('gltf-model', this.data.sceneModel);
    system.registerScene(this.el);
    system.initCanvasTextures(this);

    this.materials = {};
  },

  update: function () {
    var system = this.el.sceneEl.systems.scene;
    system.updateModel(this);
  },

  onTexturesPreloaded: function () {
    this.texturesPreloaded = true;
  }
});